import { RefObject } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { Chip } from '@frontend/design-system';
import { ChipProps } from '@frontend/design-system';
import { useCareCreditTranslations } from '../hooks/use-care-credit-translations';
import { CareCreditPatientStatus } from '../types/care-credit.types';

const styles = {
  chip: css`
    .chip-text {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: var(--fabric-space-gap-xs);
      & > .icon {
        flex-shrink: 0;
      }
    }
  `,
};

export type CareCreditChipProps = {
  status?: CareCreditPatientStatus;
  isResponsive?: boolean;
  containerRef?: RefObject<HTMLElement>;
  size?: ChipProps['size'];
};
export const CareCreditChip = ({ status, size = 'default', isResponsive, containerRef }: CareCreditChipProps) => {
  const { t } = useCareCreditTranslations();

  const iconSize = size === 'tiny' ? 12 : 16;

  if (status === 'approved') {
    return (
      <Chip
        variant='success'
        size={size}
        containerRef={containerRef}
        isResponsive={isResponsive}
        css={styles.chip}
        hideTooltip
      >
        <span className='icon'>
          <Icon name='care-credit-cardholder' size={iconSize} />
        </span>
        <span>{t('Cardholder')}</span>
      </Chip>
    );
  } else if (status === 'pre-approved') {
    return (
      <Chip
        variant='seaweed'
        size={size}
        containerRef={containerRef}
        isResponsive={isResponsive}
        css={styles.chip}
        hideTooltip
      >
        <span className='icon'>
          <Icon name='care-credit-preapproved' size={iconSize} />
        </span>
        <span>{t('Preapproved')}</span>
      </Chip>
    );
  } else if (status === 'not-enrolled') {
    return (
      <Chip
        variant='warn'
        size={size}
        containerRef={containerRef}
        isResponsive={isResponsive}
        css={styles.chip}
        hideTooltip
      >
        <span className='icon'>
          <Icon name='care-credit-prequalification-check' size={iconSize} />
        </span>
        <span>{t('Prequalification check')}</span>
      </Chip>
    );
  } else if (status === 'declined') {
    return (
      <Chip
        variant='critical'
        size={size}
        containerRef={containerRef}
        isResponsive={isResponsive}
        css={styles.chip}
        hideTooltip
      >
        <span className='icon'>
          <Icon name='x' size={iconSize} />
        </span>
        <span>{t('Declined')}</span>
      </Chip>
    );
  } else if (status === 'unknown-or-error') {
    return null;
    // return (
    //   <Chip variant='critical' size={size} containerRef={containerRef} isResponsive={isResponsive} css={styles.chip} hideTooltip>
    //     <span className='icon'>
    //       <Icon name='error-badge' size={iconSize} />
    //     </span>
    //     <span>{t('Unable to determine status')}</span>
    //   </Chip>
    // );
  }

  return null;
};
